import { getSessionPeerId } from "@/engine/state/roomIdentity";
import { useHydrated } from "./useHydrated";

/**
 * This tab's peer id, once the page has hydrated. The server has none to give,
 * and a first render that read one would disagree with the server's HTML.
 */
export function useYourPeerId(): string {
  return useHydrated() ? getSessionPeerId() : "";
}
